import { global_video_half_screen_hero } from '../../../utils/requests/contentstack/contentStackZodSchema';
import type { VideoHalfScreenHeroProps } from './VideoHalfScreenHero';
import { getCloudinarySourceUrl } from '../../../utils/getCloudinaryItem/getCloudinaryItem';
export const videoHalfScreenHeroSchema = global_video_half_screen_hero.transform<VideoHalfScreenHeroProps>(data => ({
  desktopVideo: getCloudinarySourceUrl(data.desktop_video),
  tabletVideo: getCloudinarySourceUrl(data.tablet_video),
  mobileVideo: getCloudinarySourceUrl(data.mobile_video),
  title: data.title,
  ctaCopy: data.cta_text,
  ctaHref: data.cta_href,
  description: data.description,
  signInUrl: data.sign_in_url,
  eyebrow: data.eyebrow,
  videoDescription: data.video_description,
  soundControls: data.sound_controls,
  captions: {
    url: getCloudinarySourceUrl(data.captions.file),
    default: data.captions.default,
    label: data.captions.label
  },
  variant: data.variant,
  contentOrder: data.content_order ?? 'textFirst',
  playPauseButtonSize: data.play_pause_button_size ?? 'large'
}));